import React, { useEffect, useState } from "react";
import { allocationColorsStatic } from "../../utils/constants";
import AllocationTooltip from "../AllocationTooltip/AllocationTooltip";

const SummaryStatusBar = ({ dataobj, dataSeries }) => {
  // const tooltip1 = <div>Hello</div>;
  const [cords, setCords] = useState({ x: "", y: "" });
  const [cordinates, setCordtinates] = useState(null);
  const [positionArray, setPositionArray] = useState([]);

  const getClass = (color) => ({
    position: "relative",
    display: "inline-block",
    boxSizing: "border-box",
    height: "12px",
    backgroundColor: color,
    // border-top-left-radius: '4px',
    // border-bottom-left-radius: '4px',
  });

  const getWidth = (value) => {
    let calCulated = dataSeries?.reduce((acc, curr) => {
      return (acc = acc + Number(curr.value));
    }, 0);
    if (calCulated === 100) {
      return value;
    } else if (calCulated < 100) {
      return (
        Number(value) + (1339 - (1339 * calCulated) / 100) / dataSeries?.length
      );
    } else {
      return value;
    }
  };

  const handleMouseOver = (e) => {
    setCords({
      x: e.clientX,
      y: e.clientY,
    });
  };

  useEffect(() => {
    const dom1 = document.getElementById("id1");
    let cords1 = dom1.getBoundingClientRect();
    let arryNew = Array(dataSeries?.length);
    setCordtinates(cords1);
    for (let i = 0; i < arryNew?.length; i++) {
      arryNew[i] = {
        left: document.getElementById(`span${i}`)?.getBoundingClientRect()
          ?.left,
        right: document.getElementById(`span${i}`)?.getBoundingClientRect()
          ?.right,
      };
    }
    setPositionArray(arryNew);
    // eslint-disable-next-line
  }, [document.documentElement.clientWidth]);

  return (
    <div className="status_bar_outside" id={"id1"}>
      {dataSeries?.map((data, index) => {
        if (Number(Number(data?.value).toFixed()) !== 0) {
          return (
            <span
              key={data?.id}
              id={"span" + index}
              onMouseEnter={(e) => handleMouseOver(e)}
              style={{
                width: `${getWidth(data?.value)}%`,
                ...getClass(allocationColorsStatic[data.id]),
              }}
              className="equity_status"
              data-tooltip="An Example"
            >
              <AllocationTooltip
                position={{
                  left: `${
                    cordinates?.right - cords?.x < 190
                      ? cords.x - positionArray?.[index]?.left - 190
                      : cords.x - positionArray?.[index]?.left + 5
                  }`.concat("px"),
                  top: -30 + "px",
                }}
                title={data.toolTipLabel}
                percentage={`${data.value}%`}
                bgColor={allocationColorsStatic[data.id]}
                changeClass={cordinates?.right - cords?.x}
              />
            </span>
          );
        } else return false;
      })}
    </div>
  );
};

export default SummaryStatusBar;
